import styled, { css } from 'styled-components';

import { StyledSliderProps } from './Slider.types';

import { srOnly } from '../../../';

export const StyledSingleSlider = styled.div<StyledSliderProps>`
  ${(props) => {
    if (props.itemByLine > 1 || props.lineBySlide > 1) {
      return `
          .slider__single-slide {
            margin-top: 45px;
            padding: 0px 80px;
            display: grid;
            justify-items: center;
            grid-gap: 50px;
            grid-template-columns: repeat(${props.itemByLine}, 1fr);
            grid-template-rows: repeat(${props.lineBySlide}, 1fr);
          }
        `;
    }
  }}
`;

export const StyledSlider = styled.div<StyledSliderProps>`
  position: relative;
  touch-action: pan-y;

  ${srOnly}

  .slider__slide-list {
    position: relative;
    z-index: 2;
  }

  .slide-list {
    list-style: none;
    padding: ${(props) => {
      return `0 ${props.slideListPaddingRight} 0 ${props.slideListPaddingLeft}`;
    }};
    margin: 0;
  }

  ${(props) => {
    const finalTransitionTime = props.transitionTime
      ? props.transitionTime / 1000
      : '.3';

    switch (props.transitionType) {
      case 'fade':
        return css`
          .slide-list {
            display: grid;
            .slide-list__slide {
              grid-column: 1;
              grid-row: 1;
            }
          }

          .slide-list__slide {
            pointer-events: none;
            opacity: 0;
            visibility: hidden;
            transition: all ${finalTransitionTime}s ${props.transitionEasing};
          }
          .slide-list__slide--is-selected {
            pointer-events: all;
            opacity: 1;
            visibility: visible;
            transition: all ${finalTransitionTime}s ${props.transitionEasing}
              ${finalTransitionTime}s;
          }
        `;

      case 'slide':
        return css`
          .slider__slide-list {
            overflow: hidden;
          }

          .slide-list {
            display: flex;
            //Basic slide idea: Since one slide = 100% width, translate the slide list by himself multiply by the current index.
            //When adding space between items, the same is done but you also need to add the space in calculation
            //If we add padding to the slide list (eg. For decentring the slider) we need to add it to the calculation as well
            //EG with a currentSlideIndex=2 and spacing=10px : the translate will be -200% - 2 * 10px
            transform: translate3d(
              calc(
                -${props.currentSlideIndex * 100}%${props.spacingForSlide !==
                    '0' && props.spacingForSlide !== '0px'
                    ? ` - ${props.currentSlideIndex} * ${props.spacingForSlide}`
                    : ''}${props.slideListPaddingLeft !== '0' &&
                  props.slideListPaddingLeft !== '0px'
                    ? ` + ${props.currentSlideIndex} * ${props.slideListPaddingLeft}`
                    : ''}${props.slideListPaddingRight !== '0' &&
                  props.slideListPaddingRight !== '0px'
                    ? ` + ${props.currentSlideIndex} * ${props.slideListPaddingRight}`
                    : ''}
              ),
              0,
              0
            );
            transition: all ${finalTransitionTime}s;
            .slide-list__slide {
              flex: 1 0 100%;
              margin-right: ${props.spacingForSlide};
            }
          }
        `;

      case 'rotate':
        return css`
          .slide-list {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 1fr;
            .slide-list__slide {
              grid-row: 1;
              grid-column: 1;
            }
          }

          .slide-list__slide {
            position: relative;
            opacity: 0;
            pointer-events: none;
            visibility: hidden;
            transition: all ${finalTransitionTime}s;
          }

          .slide-list__slide--is-visible {
            opacity: 1;
            pointer-events: all;
            visibility: visible;
          }
        `;
    }
  }}

  ${(props) => {
    if (props.itemByLine > 1 || props.lineBySlide > 1) {
      return css`
        .slide-list__slide {
          display: grid;
          grid-template-columns: repeat(${props.itemByLine}, 1fr);
          grid-template-rows: repeat(${props.lineBySlide}, 1fr);
        }
      `;
    }
  }}
  

  ${(props) => {
    if (
      props.isDotsEnabled &&
      props.dotsComponentClassname === 'slider-dot-list'
    ) {
      return css`
        .slider-dot-list {
          margin: 0;
          padding: 0;
          list-style: none;
          display: flex;
          justify-content: center;
          align-items: center;
          pointer-events: none;
        }

        .slider-dot {
          cursor: pointer;
          border: none;
          background: transparent;
          pointer-events: all;
        }
      `;
    }
  }}


  ${(props) => {
    if (
      props.isArrowsEnabled &&
      props.arrowsComponentClassname === 'slider-arrow-list'
    ) {
      return css`
        .slider-arrow-list {
          pointer-events: none;
          .slider-arrow {
            cursor: pointer;
            pointer-events: all;
            &--is-hidden {
              pointer-events: none;
            }
          }
        }
      `;
    }
  }}
  
  ${(props) => props.customStyle}
`;
